module.exports = __webpack_public_path__ + "static/media/icSkyMessenger.ed62627a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/components/Ecosystem/images/icSkyMessenger.svg
// module id = 909
// module chunks = 0